"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepaymentListResponseSchema = exports.prepaymentSchema = exports.prepaymentCollectionSchema = exports.cancelPrepaymentRequestSchema = exports.reversePrepaymentCollectionRequestSchema = exports.recordPrepaymentCollectionRequestSchema = exports.createPrepaymentRequestSchema = exports.manualPrepaymentMethodSchema = exports.prepaymentStatusSchema = exports.prepaymentCalculationModeSchema = exports.prepaymentIdSchema = void 0;
const zod_1 = require("zod");
const invoice_1 = require("./invoice");
const job_1 = require("./job");
const optionalTrimmedString = (maxLength) => zod_1.z
    .string()
    .trim()
    .max(maxLength)
    .optional()
    .transform((value) => value || undefined);
exports.prepaymentIdSchema = zod_1.z.string().uuid();
exports.prepaymentCalculationModeSchema = zod_1.z.enum(["FIXED", "PERCENTAGE"]);
exports.prepaymentStatusSchema = zod_1.z.enum([
    "OPEN",
    "PARTIALLY_COLLECTED",
    "COLLECTED",
    "PARTIALLY_APPLIED",
    "APPLIED",
    "REFUNDED",
    "CANCELED",
    "EXPIRED",
]);
exports.manualPrepaymentMethodSchema = invoice_1.paymentMethodSchema.exclude([
    "CARD",
]);
const prepaymentRequestBaseSchema = zod_1.z.object({
    note: optionalTrimmedString(1_000),
    expiresAt: zod_1.z.string().datetime().optional(),
    idempotencyKey: zod_1.z.string().trim().min(8).max(160),
});
exports.createPrepaymentRequestSchema = zod_1.z.discriminatedUnion("calculationMode", [
    prepaymentRequestBaseSchema.extend({
        calculationMode: zod_1.z.literal("FIXED"),
        amountCents: zod_1.z.number().int().positive(),
    }),
    prepaymentRequestBaseSchema.extend({
        calculationMode: zod_1.z.literal("PERCENTAGE"),
        percentageBasisPoints: zod_1.z.number().int().min(1).max(10_000),
    }),
]);
exports.recordPrepaymentCollectionRequestSchema = zod_1.z.object({
    method: exports.manualPrepaymentMethodSchema,
    amountCents: zod_1.z.number().int().positive(),
    receivedAt: zod_1.z.string().datetime(),
    reference: optionalTrimmedString(160),
    note: optionalTrimmedString(1_000),
    idempotencyKey: zod_1.z.string().trim().min(8).max(160),
});
exports.reversePrepaymentCollectionRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().min(2).max(1_000),
});
exports.cancelPrepaymentRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().min(2).max(1_000),
});
exports.prepaymentCollectionSchema = zod_1.z.object({
    paymentId: invoice_1.paymentIdSchema,
    method: exports.manualPrepaymentMethodSchema,
    amountCents: zod_1.z.number().int().positive(),
    receivedAt: zod_1.z.string().datetime(),
    reference: zod_1.z.string().nullable(),
    note: zod_1.z.string().nullable(),
    actorName: zod_1.z.string().nullable(),
    reversedAt: zod_1.z.string().datetime().nullable(),
    reversalReason: zod_1.z.string().nullable(),
});
exports.prepaymentSchema = zod_1.z.object({
    id: exports.prepaymentIdSchema,
    jobId: job_1.jobIdSchema,
    customerId: zod_1.z.string().uuid(),
    calculationMode: exports.prepaymentCalculationModeSchema,
    requestedAmountCents: zod_1.z.number().int().positive(),
    percentageBasisPoints: zod_1.z.number().int().min(1).max(10_000).nullable(),
    basisAmountCents: zod_1.z.number().int().nonnegative().nullable(),
    currency: zod_1.z.literal("USD"),
    status: exports.prepaymentStatusSchema,
    collectedAmountCents: zod_1.z.number().int().nonnegative(),
    appliedAmountCents: zod_1.z.number().int().nonnegative(),
    availableAmountCents: zod_1.z.number().int().nonnegative(),
    note: zod_1.z.string().nullable(),
    createdByMembershipId: zod_1.z.string().uuid(),
    createdByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime(),
    expiresAt: zod_1.z.string().datetime().nullable(),
    canceledAt: zod_1.z.string().datetime().nullable(),
    cancelReason: zod_1.z.string().nullable(),
    collections: zod_1.z.array(exports.prepaymentCollectionSchema),
});
exports.prepaymentListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.prepaymentSchema),
});
//# sourceMappingURL=prepayment.js.map